import React from 'react';
import { graphql, StaticQuery, Link } from "gatsby";
import { StaticImage } from 'gatsby-plugin-image';
import footerLogo1 from '../../images/footer-logo-new-1.svg';
import footerLogo2 from '../../images/footer-logo-new-2.svg';
import footerLogo4 from '../../images/footer-logo-new-4.svg';
import '../../sass/components/_components.footer.scss';
import twitter from '../../images/icon-twitter-white.svg';
import linkedin from '../../images/icon-linkedin-white.svg';
import facebook from '../../images/icon-facebook-white.svg';
import instagram from '../../images/icon-instagram-white.svg';
import twitterBlue from '../../images/icon-twitter-blue.svg';
import linkedinBlue from '../../images/icon-linkedin-blue.svg';
import facebookBlue from '../../images/icon-facebook-blue.svg';
import instagramBlue from '../../images/icon-instagram-blue.svg';
import planfulLogo from '../../images/planful-logo-latest-svg.svg';

const footer = ({ templateCheck }) => {
    let footerLogo3 = '//privacy-policy.truste.com/privacy-seal/seal?rid=d908531f-bce5-4bae-aec3-4add4e35e70b';
    return (
        <> 
            {templateCheck === 'no' || templateCheck === '' || templateCheck === null || !templateCheck ?
                <footer className={`cp-footer ${templateCheck === 'no' ? "l-noLanding" : "l-LandingPageFooter"}`}>
                    <div className="cp-footer__inner">
                        <div className="cp-footer__top l--flex">
                            <StaticQuery query={graphql`
                {
                allWordpressMenuItem(filter: {menu: {node: {name: {eq: "Footer Menu"}}}}) {
                edges {
                    node {
                    label
                    url
                    cssClasses
                    parentId
                    target
                    childItems {
                        nodes {
                        label
                        url
                        cssClasses
                        childItems {
                            nodes {
                            label
                            url
                            cssClasses
                            target
                            }
                        }
                        target
                        }
                    }
                    }
                }
                }
                allWordpress {
                    nodes {
                    themeSettings {
                        navigationElements {
                            footerFollowUs
                            footerPlanfulAllRightsReserved
                            footerTheFinancialPerformancePlatform
                        }
                    }
                    }
                }
                }                           
            `} render={props => (
                                    <>
                                        <div className="cp-footer__top-left">
                                            <Link to={`/`}>
                                                <img loading="lazy" src={planfulLogo} alt="Planful" />
                                            </Link>
                                            {props.allWordpress.nodes[0].themeSettings.navigationElements.footerTheFinancialPerformancePlatform &&
                                                <h2 dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.footerTheFinancialPerformancePlatform }} />
                                            }
                                            <div className="l--footerLogos">
                                                <img loading="lazy" src={footerLogo1} alt="Planful" />
                                                <img loading="lazy" src={footerLogo2} alt="Planful" />
                                                {/* <img src={footerLogo3} alt="Planful" /> */}
                                                <a href="https://privacy.truste.com/privacy-seal/validation?rid=d908531f-bce5-4bae-aec3-4add4e35e70b" target="_blank">
                                                    <img loading="lazy" src={footerLogo3} alt="TRUSTe" />
                                                </a>
                                                <img loading="lazy" src={footerLogo4} alt="Planful" />
                                            </div>
                                        </div>
                                        <div className="cp-footer__top-right">
                                            <div className="cp-footer__top-rightTop l--flex">
                                                {props.allWordpressMenuItem.edges.map((footerMenuItem, index) => (
                                                    <React.Fragment key={index}>
                                                        {footerMenuItem.node.parentId === null &&
                                                            <div className="cp-footer__top-section">
                                                                <span>{footerMenuItem.node.label}</span>
                                                                {footerMenuItem.node.childItems &&
                                                                    <>
                                                                        {footerMenuItem.node.childItems.nodes.map((footerSubMenuItem, index) => (
                                                                            <div className="cp-footer__top-list" key={index}>
                                                                                {footerSubMenuItem.target === '_blank' ?
                                                                                    <a href={`${footerSubMenuItem.url}`} target="_blank" rel="noreferrer">{footerSubMenuItem.label}</a>
                                                                                    :
                                                                                    <a href={`${footerSubMenuItem.url}`}>{footerSubMenuItem.label}</a>
                                                                                }
                                                                            </div>
                                                                        ))}
                                                                    </>
                                                                }
                                                            </div>
                                                        }
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                            <div className="cp-footer__top-rightBottom l--flex">
                                                <div className="cp-footer__bottom-social l--social l--flex">
                                                    {props.allWordpress.nodes[0].themeSettings.navigationElements.footerFollowUs &&
                                                        <span dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.footerFollowUs }} />
                                                    }
                                                    <a className="l--genericBorderRadius l--flex" href="https://twitter.com/Planful" target="_blank" rel="noreferrer" aria-label="Twitter, opens in a new tab">
                                                        <img loading="lazy" src={twitter} alt="Twitter" />
                                                    </a>
                                                    <a className="l--genericBorderRadius l--flex" href="https://www.linkedin.com/company/planful-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn, opens in a new tab">
                                                        <img loading="lazy" src={linkedin} alt="LinkedIn" />
                                                    </a>
                                                    <a className="l--genericBorderRadius l--flex" href="https://www.facebook.com/PlanfulInc/" target="_blank" rel="noreferrer" aria-label="Facebook, opens in a new tab">
                                                        <img loading="lazy" src={facebook} alt="Facebook" />
                                                    </a>
                                                    <a className="l--genericBorderRadius l--flex" href="https://www.instagram.com/planful_inc/" target="_blank" rel="noreferrer" aria-label="Instagram, opens in a new tab">
                                                        <img loading="lazy" src={instagram} alt="Instagram" />
                                                    </a>
                                                </div>
                                                <span className="cp-footer__bottom-copyright">© {new Date().getFullYear()}
                                                    {props.allWordpress.nodes[0].themeSettings.navigationElements.footerPlanfulAllRightsReserved &&
                                                        <span dangerouslySetInnerHTML={{ __html: props.allWordpress.nodes[0].themeSettings.navigationElements.footerPlanfulAllRightsReserved }} />
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                )} />
                        </div>
                    </div>
                </footer>
                :
                <footer className="cp-landingPageFooter">
                    <div className="cp-landingPageFooter__inner l--flex">
                        <Link to={`/`}>
                            <img loading="lazy" src={planfulLogo} alt="Planful" />
                        </Link>
                        <span className="cp-footer__bottom-copyright l-desktop">© {new Date().getFullYear()} Planful. All rights reserved.</span>
                        <div className="cp-footer__bottom-social l--social l--flex">
                            <a className="l--genericBorderRadius l--flex" href="https://twitter.com/Planful" target="_blank" rel="noreferrer" aria-label="Twitter, opens in a new tab">
                                <img loading="lazy" src={twitterBlue} alt="Twitter" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.linkedin.com/company/planful-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn, opens in a new tab">
                                <img loading="lazy" src={linkedinBlue} alt="LinkedIn" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.facebook.com/PlanfulInc/" target="_blank" rel="noreferrer" aria-label="Facebook, opens in a new tab">
                                <img loading="lazy" src={facebookBlue} alt="Facebook" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.instagram.com/planful_inc/" target="_blank" rel="noreferrer" aria-label="Instagram, opens in a new tab">
                                <img loading="lazy" src={instagramBlue} alt="Instagram" />
                            </a>
                        </div>
                        <span className="cp-footer__bottom-copyright l-mobile">© {new Date().getFullYear()} Planful. All rights reserved.</span>
                    </div>
                </footer>
            }
        </>
    )
};

export default footer;